













import { CreateElement, RenderContext } from "vue";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class UCouponCode extends Vue {
  // Props

  @Prop({ required: true })
  public coupon!: string;

  @Prop({ default: null })
  public tooltip!: string;

  @Prop({ default: false })
  public isProcessing!: boolean;

  // Computed

  public get component() {
    return {
      functional: true,
      render: (h: CreateElement, { children }: RenderContext) => {
        const vNodeData = { staticClass: "u-coupon-code" };
        if (this.tooltip?.length)
          return h(
            "b-tooltip",
            {
              ...vNodeData,
              class: "has-cursor-help",
              props: {
                label: this.tooltip.trim(),
                multilined: true,
                type: "is-dark"
              }
            },
            children
          );
        return h("div", vNodeData, children);
      }
    };
  }
}
